import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'

import style from './style.css'

/**
 * Use when you need the browser to focus on a container when it's mounted/updated.
 * Helpful for accessibility.
 * Not needed when using react-bootstrap/Modal.
 */
export default class AutoFocus extends Component {
  componentDidMount () {
    this.focus()
  }

  componentDidUpdate (prevProps) {
    if (this.props.alwaysFocusOnUpdate) {
      this.focus()
    } else if (_.has(this.props, 'check') && !_.isEqual(prevProps.check, this.props.check)) {
      this.focus()
    }
  }

  focus () {
    setTimeout(() => {
      this.refs.container?.focus()
    }, 0)
  }

  render () {
    const restProps = _.omit(this.props, 'check')
    return (
      <div
        ref="container"
        tabIndex="-1"
        {...restProps}
        className={classnames(style.container, this.props.className)}
      >
        {this.props.children}
      </div>
    )
  }
}

AutoFocus.propTypes = {
  children: PropTypes.node,
  alwaysFocusOnUpdate: PropTypes.bool,
  className: PropTypes.string,
  check: PropTypes.any // if the `check` value changes between renders, the component will re-focus
}
